<template>
  <div id="order-page" style="position: relative" v-if="order">
    <Note collection="orders" :objectId="order.id" />
    <div
      v-if="order.legalStatus"
      style="color:red;font-weight: bold;margin-top: 20px"
    >
      LEGAL DISPUTE
    </div>
    <table style="margin: 0 auto;margin-top: 30px;max-width: 600px;">
      <tr>
        <td>Order code</td>
        <td>
          <b>{{ order.code }}</b>
        </td>
      </tr>
      <tr>
        <td>Order type</td>
        <td>
          {{ order.jobId ? "FIXED" : "HOURLY" }}
          {{ order.companyId ? "B2B" : "B2C" }}
          {{ order.paymentType === "client" ? "PROMO" : "" }}
          {{ order.assignmentStrategy }}
        </td>
      </tr>
      <tr>
        <td>Payment handler</td>
        <td>
          {{
            order.paymentType === "client" || !order.companyId
              ? "Discontract, after completion"
              : "Company"
          }}
          {{
            order.paymentType === "clientExpenses"
              ? " (prepaid) , Discontract expenses"
              : ""
          }}
        </td>
      </tr>
      <tr>
        <td>Status</td>
        <td>
          <b>{{ order.status }}</b>
        </td>
      </tr>
      <tr>
        <td>Seen by PRO</td>
        <td>
          <b>
            <span v-if="order.seenAt">SEEN {{ order.seenAt }}</span>
            <span v-else>NOT SEEN</span>
          </b>
        </td>
      </tr>
      <tr v-if="order.contactId">
        <td>Contact Status</td>
        <td>
          <b>
            <span v-if="order.status === 'confirmed'"
              ><a
                :href="
                  'https://discontract.com/o/' +
                    order.code +
                    '-' +
                    order.id.substr(0, 3) +
                    '?debug=true'
                "
                >Info Link</a
              >
            </span>
            <span v-if="order.contactOpenedDetailsPageAt">
              SEEN {{ order.contactSeenAt }}
            </span>
            <span v-if="order.clientId"> USER</span>
          </b>
        </td>
      </tr>
      <tr>
        <td>Skill</td>
        <td>{{ skill.localizedTitle.lt }}</td>
      </tr>
      <tr>
        <td>Description</td>
        <td>{{ order.details.comment.textValue }}</td>
      </tr>
      <tr>
        <td>Address</td>
        <td class="actions">
          <div v-if="editAddress">
            <input
              v-model="addressInput"
              :placeholder="order.details.address.textValue"
              @input="getLocations"
              style="border: 1px solid gray; padding: 5px"
            />
            <div>
              <div
                v-for="(suggestion, i) in addressSuggestions"
                :key="i"
                style="border: 1px solid gray; padding: 5px;cursor:pointer;"
                @click="updateOrderAddress(suggestion)"
              >
                {{ suggestion.description }}
              </div>
            </div>
          </div>
          <div v-else>
            <router-link
              :to="{
                name: 'users',
                query: {
                  filter: 'search',
                  address: order.details.address.textValue,
                  country: order.country,
                  ...order.details.address.location
                }
              }"
            >
              {{ order.details.address.textValue }}
            </router-link>
            <button @click="editAddress = true">Edit</button>
          </div>
        </td>
      </tr>
      <tr>
        <td>Scheduled at</td>
        <td>{{ getScheduledAt() }}</td>
      </tr>
      <tr v-if="order.details.ownerComment">
        <td>Owner comment</td>
        <td>
          {{ (order.details.ownerComment || { textValue: "" }).textValue }}
        </td>
      </tr>
      <tr v-if="order.details.attachments">
        <td>Attachments</td>
        <td>
          <div v-for="(file, i) in order.details.attachments.files" :key="i">
            <a :href="file.fullPath" target="_blank">{{ file.name }}</a>
          </div>
        </td>
      </tr>
    </table>

    <div
      style="display:flex;justify-content: center;margin-bottom: 30px;margin-top: 30px"
    >
      <table>
        <tr v-if="company">
          <td>Company</td>
          <td>
            <router-link
              :to="{ name: 'companyPage', params: { id: order.companyId } }"
              >{{ company.name }}</router-link
            >
          </td>
        </tr>
        <tr v-if="order.cartId">
          <td>Cart</td>
          <td>
            <router-link
              :to="{ name: 'cartPage', params: { id: order.cartId } }"
              >{{ order.cartId }}</router-link
            >
          </td>
        </tr>
        <tr v-if="owner">
          <td>Owner</td>
          <td>
            <router-link
              :to="{ name: 'userProfile', params: { id: owner.id } }"
              >{{ owner.firstName + " " + owner.lastName }}</router-link
            ><router-link
              style="margin-left:20px"
              :to="{ name: 'call', query: { phoneNumber: owner.phoneNumber } }"
              >{{ owner.phoneNumber }}</router-link
            >
          </td>
        </tr>
        <tr v-if="order.departmentExternalId">
          <td>Department</td>
          <td>
            {{
              (
                company.departmentsList.find(
                  d => d.externalId === order.departmentExternalId
                ) || {}
              ).name
            }}
          </td>
        </tr>
        <tr v-if="order.ownerExternalId">
          <td>Owner (external)</td>
          <td>{{ order.ownerExternalId }}</td>
        </tr>
        <tr v-if="admin">
          <td>Admin</td>
          <td>
            <router-link
              :to="{ name: 'userProfile', params: { id: admin.id } }"
              >{{ admin.firstName + " " + admin.lastName }}</router-link
            ><router-link
              style="margin-left:20px"
              :to="{ name: 'call', query: { phoneNumber: admin.phoneNumber } }"
              >{{ admin.phoneNumber }}</router-link
            >
          </td>
        </tr>
        <tr v-if="client">
          <td>Client</td>
          <td>
            <router-link
              :to="{ name: 'userProfile', params: { id: client.id } }"
              >{{ client.firstName + " " + client.lastName }}</router-link
            ><router-link
              style="margin-left:20px"
              :to="{ name: 'call', query: { phoneNumber: client.phoneNumber } }"
              >{{ client.phoneNumber }}</router-link
            >
          </td>
        </tr>
        <tr v-if="contact">
          <td>Contact</td>
          <td>
            {{ contact.firstName + " " + contact.lastName
            }}<router-link
              :to="{
                name: 'call',
                query: { phoneNumber: contact.phoneNumber }
              }"
              style="margin-left:20px"
              >{{ contact.phoneNumber }}</router-link
            ><span
              v-if="order.contactOpenedDetailsPageAt"
              style="font-weight: bold;"
            >
              VERIFIED</span
            >
            <div style="margin-top: 10px" class="actions">
              <select v-model="smsText">
                <option
                  v-if="getPaymentAmount()"
                  :value="
                    `Sumokėkite ${getPaymentAmount().toFixed(
                      2
                    )} € už paslaugas https://discontract.com/pay/` + order.id
                  "
                  >Kevin link</option
                >
                <option v-if="getPaymentAmount()" :value="getTransferTemplate()"
                  >Bank transfer</option
                >
                <option
                  :value="
                    `Meistro kontaktai: ${worker.firstName} ${worker.phoneNumber}`
                  "
                  >Pro contacts</option
                >
                <option
                  v-if="task.supportNumber"
                  :value="
                    `Meistro kontaktai: ${worker.firstName} ${task.supportNumber}`
                  "
                  >Pro callcentre number</option
                >
                <option
                  :value="`Dėkui, gavome mokėjimą už paslaugą ${order.code}.`"
                  >Payment received</option
                >
              </select>
              <router-link
                :to="{
                  name: 'call',
                  query: { phoneNumber: contact.phoneNumber, text: smsText }
                }"
                ><button style="margin-left: 10px">
                  Compose SMS
                </button></router-link
              >
            </div>
          </td>
        </tr>
        <tr v-if="worker">
          <td>PRO</td>
          <td>
            <router-link
              :to="{ name: 'userProfile', params: { id: worker.id } }"
              >{{ worker.firstName + " " + worker.lastName }}</router-link
            ><router-link
              style="margin-left:20px"
              :to="{ name: 'call', query: { phoneNumber: worker.phoneNumber } }"
              >{{ worker.phoneNumber }}</router-link
            >
            <div style="margin-top: 10px" class="actions">
              <select v-model="smsText">
                <option
                  :value="
                    `Kliento kontaktai: ${(contact || client).firstName} ${
                      (contact || client).phoneNumber
                    }`
                  "
                  >Client contacts</option
                >
              </select>
              <router-link
                :to="{
                  name: 'call',
                  query: { phoneNumber: worker.phoneNumber, text: smsText }
                }"
                ><button style="margin-left: 10px">
                  Compose SMS
                </button></router-link
              >
            </div>
          </td>
        </tr>
        <tr>
          <td class="actions">
            Invoice details<br />
            <button
              v-if="editingInvoiceDetails"
              @click="updateClientInvoiceDetails"
            >
              Save
            </button>
            <button v-else @click="editingInvoiceDetails = true">Edit</button>
          </td>
          <td>
            <div v-if="editingInvoiceDetails">
              <table>
                <tr>
                  <td>First Name</td>
                  <td>
                    <input v-model="order.clientInvoiceDetails.firstName" />
                  </td>
                </tr>
                <tr>
                  <td>Last Name</td>
                  <td>
                    <input v-model="order.clientInvoiceDetails.lastName" />
                  </td>
                </tr>
                <tr>
                  <td>Email</td>
                  <td><input v-model="order.clientInvoiceDetails.email" /></td>
                </tr>
                <tr>
                  <td>Company Name</td>
                  <td>
                    <input v-model="order.clientInvoiceDetails.businessName" />
                  </td>
                </tr>
                <tr>
                  <td>Vat Code</td>
                  <td>
                    <input v-model="order.clientInvoiceDetails.vatCode" />
                  </td>
                </tr>
                <tr>
                  <td>Business Code</td>
                  <td>
                    <input v-model="order.clientInvoiceDetails.businessCode" />
                  </td>
                </tr>
                <tr>
                  <td>Address</td>
                  <td>
                    <input
                      v-model="order.clientInvoiceDetails.address.streetLine1"
                      placeholder="Street address"
                    /><br />
                    <input
                      v-model="order.clientInvoiceDetails.address.city"
                      placeholder="City"
                    /><br />
                    <input
                      v-model="order.clientInvoiceDetails.address.postcode"
                      placeholder="Postcode"
                    />
                  </td>
                </tr>
              </table>
            </div>
            <div v-else>
              <table
                v-if="
                  order.clientInvoiceDetails &&
                    order.clientInvoiceDetails.firstName
                "
              >
                <tr>
                  <td>First Name</td>
                  <td>{{ order.clientInvoiceDetails.firstName }}</td>
                </tr>
                <tr>
                  <td>Last Name</td>
                  <td>{{ order.clientInvoiceDetails.lastName }}</td>
                </tr>
                <tr>
                  <td>Email</td>
                  <td>{{ order.clientInvoiceDetails.email }}</td>
                </tr>
                <tr>
                  <td>Company Name</td>
                  <td>{{ order.clientInvoiceDetails.businessName }}</td>
                </tr>
                <tr>
                  <td>Vat Code</td>
                  <td>{{ order.clientInvoiceDetails.vatCode }}</td>
                </tr>
                <tr>
                  <td>Business Code</td>
                  <td>{{ order.clientInvoiceDetails.businessCode }}</td>
                </tr>
                <tr v-if="order.clientInvoiceDetails.address.streetLine1">
                  <td>Address</td>
                  <td>
                    {{ order.clientInvoiceDetails.address.streetLine1 }}<br />
                    {{ order.clientInvoiceDetails.address.city }}<br />
                    {{ order.clientInvoiceDetails.address.postcode }}
                  </td>
                </tr>
              </table>

              <div v-else-if="order.clientInvoiceDetails.comanyId">
                Company default
              </div>
              <div v-else-if="order.clientInvoiceDetails.clientId">
                User default
              </div>
            </div>
          </td>
        </tr>
      </table>

      <div
        style="display:flex;margin-bottom: 20px;flex-direction: column; margin-left: 10px"
        v-if="order.worklog"
      >
        <table>
          <tr v-if="order.worklog.externalPrice">
            <td>External price</td>
            <td>{{ (order.worklog.externalPrice / 100).toFixed(2) }}</td>
          </tr>
          <tr v-if="order.worklog.unitPrice">
            <td>Unit cost</td>
            <td>{{ (order.worklog.unitPrice / 100).toFixed(2) }}</td>
          </tr>
          <tr v-if="order.worklog.adjustedUnitPrice">
            <td>Unit price with fee</td>
            <td>{{ (order.worklog.adjustedUnitPrice / 100).toFixed(2) }}</td>
          </tr>
          <!-- <tr v-if="order.worklog.feePercentage">
            <td>Fee</td>
            <td>{{ (order.worklog.feePercentage * 100).toFixed(2) }}</td>
          </tr> -->
          <tr v-if="order.worklog.rate">
            <td>Rate</td>
            <td>{{ (order.worklog.rate / 100).toFixed(2) }}</td>
          </tr>
          <tr v-if="order.worklog.adjustedRate">
            <td>Adjusted rate</td>
            <td>{{ (order.worklog.adjustedRate / 100).toFixed(2) }}</td>
          </tr>
          <tr v-if="order.worklog.amount">
            <td>Amount</td>
            <td>{{ order.worklog.amount }}</td>
          </tr>
          <tr v-if="!order.worklog.duration">
            <td>Estimate</td>
            <td>{{ order.details.estimate.estimatedTime }}</td>
          </tr>
          <tr v-if="order.worklog.duration">
            <td>Duration</td>
            <td>{{ order.worklog.duration }}</td>
          </tr>
          <tr>
            <td>Express cost</td>
            <td>{{ (order.worklog.arrivalCost / 100).toFixed(2) }}</td>
          </tr>
          <tr>
            <td>Distance cost</td>
            <td>{{ ((order.worklog.distanceCost || 0) / 100).toFixed(2) }}</td>
          </tr>
          <tr>
            <td>Subtotal</td>
            <td>{{ (order.worklog.subtotal / 100).toFixed(2) }}</td>
          </tr>
          <tr>
            <td>Expenses</td>
            <td>{{ (order.worklog.expenses / 100).toFixed(2) }}</td>
          </tr>
          <tr>
            <td>Total</td>
            <td>{{ (order.worklog.total / 100).toFixed(2) }}</td>
          </tr>
          <tr v-if="allowToUpdateDiscount()">
            <td>Discount</td>
            <td class="actions">
              <input v-model="discountAmount" /><br />
              <button @click="updateDiscount()">Update discount</button>
            </td>
          </tr>
          <tr v-else>
            <td>Discount</td>
            <td>{{ (order.worklog.discountAmount / 100).toFixed(2) }}</td>
          </tr>
          <tr style="font-weight: bold;">
            <td>Discounted Total</td>
            <td>{{ (order.worklog.discountedTotal / 100).toFixed(2) }}</td>
          </tr>
          <tr style="font-weight: bold;" v-if="order.worklog.callOutFee">
            <td>Call out fee</td>
            <td>{{ (order.worklog.callOutFee / 100).toFixed(2) }}</td>
          </tr>
          <tr v-if="order.worklog.paymentTotal">
            <td>Payment Total</td>
            <td>{{ (order.worklog.paymentTotal / 100).toFixed(2) }}</td>
          </tr>
          <tr v-if="order.jobId && order.status === 'confirmed'">
            <td>Pro Total</td>
            <td>
              <input style="width:50px" v-model="proTotal" /><br /><button
                @click="updateProTotal"
                style="margin-top: 5px; padding: 2px; color: white;cursor:pointer;background-color: orange"
              >
                Update
              </button>
            </td>
          </tr>
          <tr style="font-weight: bold;" v-else>
            <td>Pro Total</td>
            <td>{{ (order.worklog.proTotal / 100).toFixed(2) }}</td>
          </tr>
          <tr style="font-weight: bold;" v-if="getPaymentAmount() && order.paymentStatus">
            <td>Payment amount:</td>
            <td>
              {{ getPaymentAmount().toFixed(2) }}<br /><a
                :href="'https://discontract.com/pay/' + order.id"
                >Payment Link</a
              >
            </td>
          </tr>
          <tr v-else-if="order.paymentStatus">
            <td>Payment status:</td>
            <td>{{ order.paymentStatus }}</td>
          </tr>
          <tr v-if="order.status === 'confirmed'">
            <td colspan="2"><button @click="convertToArrival" style="cursor:pointer;background-color: orange;color:white;padding:2px">Convert to arrival</button>
          </td></tr>
        </table>

        <div style="display:flex;flex-direction: column;">
          <button
            v-if="
              order.worklog.paymentAmount &&
                !order.worklog.expensesDiscount &&
                order.paymentType === 'clientExpenses'
            "
            style="border: 1px solid black; background-color: red; padding: 10px; color: white;cursor: pointer"
            v-on:click="coverExpenses()"
          >
            COVER EXPENSES WITH A DISCOUNT
          </button>
          <button
            v-if="order.worklog.paymentAmount"
            style="border: 1px solid black; background-color: orange; padding: 10px; color: white;cursor: pointer;"
            v-on:click="clearPayment()"
          >
            MARK PAYMENT AS PAID VIA TRANSFER
          </button>
        </div>
      </div>
    </div>
    <table style="margin: 0 auto;">
      <tr v-for="event in order.events" v-bind:key="event.publishedAt.seconds">
        <td>
          {{
            new Date(
              event.publishedAt._seconds * 1000
            ).toLocaleDateString(undefined, {
              hour12: false,
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit"
            })
          }}
        </td>
        <td>
          {{ event.type }}
          <span v-if="event.prevScheduledAt"
            ><br />from: {{ formatDate(event.prevScheduledAt) }}<br />to:
            {{ formatDate(event.scheduledAt) }}</span
          >
        </td>
        <td>
          <a v-if="event.recordingUrl" v-bind:href="event.recordingUrl"
            >Irasas (duration: {{ event.duration }}s)</a
          >
          <span v-if="event.workerId">
            Worker:
            <router-link
              :to="{ name: 'userProfile', params: { id: event.workerId } }"
              >{{ event.workerId }}</router-link
            >
          </span>
          <span v-if="event.callerId"
            >Initiated by
            {{
              event.callerId == order.clientId ? "the client" : "the worker"
            }}</span
          >
        </td>
      </tr>
    </table>

    <div class="actions">
      <div
        v-if="
          order.status != 'cancelled' && order.status != 'completed' && task
        "
      >
        Cancel culprit:
        <select v-model="cancelCulpritId">
          <option value="">NONE</option>
          <option :value="order.workerId">{{
            worker.firstName + " " + worker.lastName
          }}</option>
        </select>
        <button v-on:click="cancelOrder()">Cancel order</button>
      </div>
      <div v-if="order.proPaymentScheduledAt">
        <button v-on:click="stopAutopayment()">Cancel autopayment</button>
      </div>
      <br />
      <button
        v-if="
          (task.status == 'new' || task.status == 'confirmed') &&
            !order.companyId
        "
        v-on:click="rejectTask()"
      >
        Reject task
      </button>
      <button
        v-if="
          (task.status == 'rejected' || task.status == 'transferred') &&
            !order.companyId
        "
        v-on:click="reopenTask()"
      >
        Reopen task for 24h
      </button>
      <button
        v-if="order.status == 'confirmed' && !task.supportNumber"
        v-on:click="assignPhoneNumber()"
      >
        Assign phone number
      </button>
    </div>

    <div v-if="chat.length">
      <h1 style="margin: 20px">Chat History PRO with Client</h1>
      <table style="margin: 0 auto;">
        <tr v-for="message in chat" v-bind:key="message.id">
          <td>
            {{
              new Date(
                message.createdAt._seconds * 1000
              ).toLocaleDateString(undefined, {
                hour12: false,
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit"
              })
            }}
          </td>
          <td>
            <router-link
              :to="{ name: 'userProfile', params: { id: message.authorId } }"
              >{{ message.authorId }}</router-link
            >
          </td>
          <td>{{ message.text }}</td>
        </tr>
      </table>
    </div>

    <div v-if="chatAdmin && chatAdmin.length" style="margin-bottom: 20px">
      <h1 style="margin: 20px">Chat History PRO with Admin</h1>
      <table style="margin: 0 auto;">
        <tr v-for="message in chatAdmin" v-bind:key="message.id">
          <td>
            {{
              new Date(
                message.createdAt._seconds * 1000
              ).toLocaleDateString(undefined, {
                hour12: false,
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit"
              })
            }}
          </td>
          <td>
            <router-link
              :to="{ name: 'userProfile', params: { id: message.userId } }"
              >{{ message.userId }}</router-link
            >
          </td>
          <td>
            {{ message.text
            }}<a
              v-if="message.images && message.images.length"
              :href="message.images[0].downloadURL"
              >Image</a
            >
          </td>
        </tr>
      </table>
    </div>

    <div v-if="task && task.completionDetails">
      <h1 style="margin: 20px">Completion Details</h1>
      <div>
        {{
          task.completionDetails.comment &&
            task.completionDetails.comment.textValue
        }}
      </div>
      <div
        v-if="
          task.completionDetails.gallery &&
            task.completionDetails.gallery.images
        "
      >
        <div
          v-for="(image, i) in task.completionDetails.gallery.images"
          :key="i"
        >
          <a :href="image.downloadURL">{{ image.downloadURL }}</a>
        </div>
      </div>
      <h1 style="margin: 20px">Expenses Details</h1>
      <div>
        {{
          task.completionDetails.expenses &&
            task.completionDetails.expenses.title
        }}
      </div>
      <div
        v-if="
          task.completionDetails.expenses &&
            task.completionDetails.expenses.images
        "
      >
        <div
          v-for="(image, i) in task.completionDetails.expenses.images"
          :key="i"
        >
          <a :href="image.downloadURL">{{ image.downloadURL }}</a>
        </div>
      </div>
    </div>

    <div
      v-if="order.companyId"
      class="actions"
      style="margin-bottom: 15px; border: 1px solid black; display: flex; flex-direction: column; max-width: 450px; margin: 0 auto; padding: 10px; margin-bottom: 20px; "
    >
      <h1>TransferOrder</h1>
      <select name="transferablePro" v-model="proId" style="margin-top:10px">
        <option v-for="pro in availablePros" :key="pro.id" :value="pro.id">{{
          pro.firstName + " " + pro.lastName
        }}</option>
      </select>
      <br />
      <!-- <div> -->
      <input
        style="border: 1px solid black; margin-top: 10px"
        v-model.trim="proId"
        @input="loadTransferUser"
      />
      <router-link
        v-if="getTransferProDisplayName()"
        :to="{ name: 'userProfile', params: { id: proId } }"
        style="margin-top: 10px"
        >{{ getTransferProDisplayName() }}</router-link
      >
      <!-- </div> -->
      <div>
        Add penalty to previous pro
        <input type="checkbox" v-model="addPenalty" />
      </div>
      <div
        v-if="rescheduleAt"
        style="display:inline-block; margin-top:10px; font-weight: bold;"
      >
        {{
          dayjs(rescheduleAt)
            .tz(timezone)
            .format("YYYY-MM-DD HH:mm")
        }}
      </div>
      <button
        v-if="getTransferProDisplayName()"
        style="padding: 10px;"
        v-on:click="transferOrder()"
      >
        Transfer</button
      ><br />
      Keep in mind, that current arrival cost for order is
      {{ order.worklog ? order.worklog.arrivalCost / 100 : 0 }} EUR<br />
      The order was created on {{ new Date(order.createdAt._seconds * 1000) }}
    </div>

    <div
      v-if="!showInvoice && order.companyId"
      style="display:flex; background-color: white; overflow-x: scroll"
    >
      <DatePicker
        :timezone="timezone"
        :currentPro="order.workerId"
        :availabilitySlots="order.rescheduleDates || []"
        renderEmpty
        :scheduledAt="task && task.datetime && task.datetime.timestamp"
        @save="onPressDate"
      />
    </div>

    <h1 v-if="showInvoice" style="margin: 20px">Invoice</h1>
    <h1 v-if="showInvoice || order.status === 'cancelled'" style="margin: 20px">
      <div v-if="getOrderDebt()" style="color: red">
        PRO order debt: {{ getOrderDebt().amount / 100 }}
        <span style="color:black">{{ getOrderDebt().comment || "" }}</span>
      </div>
      <div v-if="!getOrderDebt() || getOrderDebt().amount < 0" class="actions">
        <span style="color:brown">Add PRO debt: </span>
        <input
          v-model="debt"
          placeholder="amount"
          style="border:1px solid gray; padding: 10px"
        />
        <input
          v-model="debtComment"
          placeholder="comment"
          style="border:1px solid gray; padding: 10px"
        />
        <button @click="addProDebt">Add debt</button>
      </div>
    </h1>
    <h1
      v-if="(showInvoice || order.status === 'cancelled') && order.companyId"
      style="margin: 20px"
    >
      <div v-if="getCompanyDebt()" style="color: red">
        Company order debt: {{ getCompanyDebt().amount / 100 }}
        <span style="color:black">{{ getCompanyDebt().comment || "" }}</span>
      </div>
      <div v-else class="actions">
        <span style="color:brown">Add Company debt: </span>
        <input
          v-model="companyDebt"
          placeholder="amount"
          style="border:1px solid gray; padding: 10px"
        />
        <input
          v-model="companyDebtComment"
          placeholder="comment"
          style="border:1px solid gray; padding: 10px"
        />
        <button @click="addCompanyDebt">Add debt</button>
      </div>
    </h1>
    <div v-if="showInvoice">
      <div class="data-table" id="order-table">
        <div class="header">
          <div></div>
          <div>Order</div>
          <div>Invoice</div>
        </div>
        <div class="cell">id</div>
        <div class="cell">{{ order.id }}</div>
        <div class="cell">{{ order.invoiceId }}</div>
        <div class="cell">date</div>
        <div class="cell">
          {{
            order.createdAt
              ? new Date(order.createdAt._seconds * 1000).toLocaleDateString()
              : "-"
          }}
        </div>
        <div class="cell">{{ invoice.invoiceDate }}</div>
        <div class="cell">documentNumber</div>
        <div class="cell"></div>
        <div class="cell">{{ invoice.documentNumber }}</div>
        <div class="cell">proDocumentNumber</div>
        <div class="cell"></div>
        <div class="cell">{{ invoice.proDocumentNumber }}</div>
        <div class="cell">clientFeeDocumentNumber</div>
        <div class="cell"></div>
        <div class="cell">{{ invoice.clientFeeDocumentNumber }}</div>
        <div class="cell">clientEmailSent</div>
        <div class="cell"></div>
        <div class="cell">{{ invoice.clientEmailSent ? "true" : "false" }}</div>
        <div class="cell">proEmailSent</div>
        <div class="cell"></div>
        <div class="cell">{{ invoice.proEmailSent ? "true" : "false" }}</div>
        <div class="cell">pdfGeneratedAt</div>
        <div class="cell"></div>
        <div class="cell">
          {{ invoice.pdfGeneratedAt }}
        </div>
        <div class="cell">Pro PDF</div>
        <div class="cell"></div>
        <div class="cell">
          <a
            v-if="getInvoiceUrl(invoice.proPdfLink)"
            :href="getInvoiceUrl(invoice.proPdfLink)"
            >Download</a
          >
        </div>
        <div class="cell">Pro fee PDF</div>
        <div class="cell"></div>
        <div class="cell">
          <a
            v-if="getInvoiceUrl(invoice.dscPdfLink)"
            :href="getInvoiceUrl(invoice.dscPdfLink)"
            >Download</a
          >
        </div>
        <div class="cell">Client fee PDF</div>
        <div class="cell"></div>
        <div class="cell">
          <a
            v-if="invoice.clientFeePdfLink"
            :href="getInvoiceUrl(invoice.clientFeePdfLink)"
            >Download</a
          >
        </div>
        <div class="cell">actions</div>
        <div class="cell actions">
          <button
            v-on:click="deleteInvoice(order.invoiceId)"
            style="color:white;background-color:red"
          >
            Delete Invoice
          </button>
          <button v-on:click="regenerateInvoice(order.id)">
            Regenerate Invoice
          </button>
        </div>
        <div class="cell actions">
          <button
            v-if="!invoice.registrationNo"
            v-on:click="registerInvoice(order.invoiceId)"
          >
            Register Invoice
          </button>
          <button v-on:click="generatePdf(order.invoiceId)">
            Regenerate PDF
          </button>
          <button
            v-if="!invoice.proEmailSent"
            v-on:click="sendProEmail(order.invoiceId)"
          >
            Send Pro Email
          </button>
          <button
            v-if="!invoice.clientEmailSent"
            v-on:click="sendClientEmail(order.invoiceId)"
          >
            Send Client Email
          </button>
          <button v-on:click="sendPayment(order)" v-if="canSendPayment(order)">
            Send&nbsp;Payment
          </button>
        </div>
      </div>
      <p>&nbsp;</p>
    </div>
    <div
      v-if="
        (order.status === 'cancelled' || order.status === 'completed') &&
          !order.legalStatus
      "
      class="actions"
    >
      <button v-on:click="markAsDispute(order.id)">
        MARK ORDER AS LEGAL DISPUTE
      </button>
    </div>
  </div>
</template>

<style scoped lang="less">
#order-page {
  table {
    td {
      border: 1px solid #999;
      border-collapse: collapse;
      margin: 0;
      padding: 10px;
    }
  }
}
</style>

<script>
import api from "../services/api";
import DatePicker from "../components/DatePicker.vue";
import Note from "../components/Note.vue";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
dayjs.extend(utc);
dayjs.extend(timezone);
const timezones = {
  PL: "Europe/Warsaw",
  LT: "Europe/Vilnius"
};
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: "home",
  components: {
    DatePicker,
    Note
  },
  methods: {
    allowToUpdateDiscount() {
      return (
        this.order.status == "completed" &&
        this.order.completedAt &&
        +new Date() / 1000 - this.order.completedAt._seconds < 3600 * 24 * 30 &&
        this.order.paymentType !== "clientExpenses"
      );
    },
    getTransferTemplate() {
      return `Sveiki, štai rekvizitai apmokėjimui pavedimu:

UAB Virtualioji darbo rinka
Įm. k. 305321397
Banko sąskaita: LT103250096802339012
Mokėjimo paskirtis: ${this.order.code || "užsakymas"}
Suma: ${this.getPaymentAmount().toFixed(2)} Eur

Geros dienos!`;
    },
    timeDiff(t1, t2) {
      if (t1 && t2) {
        const mins = Math.round(((t1._seconds - t2._seconds) / 60) * 100) / 100;
        if (mins < 1800) {
          return mins + "min.";
        }
      }
    },
    async getLocations() {
      if (this.addressInput.length > 3) {
        const resp = await api.getLocations(this.addressInput);
        this.addressSuggestions = resp;
      } else {
        this.addressSuggestions = [];
      }
    },
    async convertToArrival() {
      if (confirm(`Did pro arrive and services could not be performed? Worklog will be converted to arrival cost only.`)) {
        await api.convertToArrival(this.order.id);
        window.location.reload();
      }
    },
    async updateOrderAddress(selection) {
      if (confirm(`Update order address to ` + selection.description + " ?")) {
        await api.updateOrderAddress(this.order.id, selection);
        window.location.reload();
      }
    },
    async updateClientInvoiceDetails() {
      if (
        confirm(
          `Update client invoice details? Keep in mind that you have to 'Regnerate Invoice', 'Regenerate Pdfs', 'Send Pdfs' after this action if order was already completed`
        )
      ) {
        await api.updateClientInvoiceDetails(
          this.order.id,
          this.order.clientInvoiceDetails
        );
        window.location.reload();
      }
    },
    async updateProTotal() {
      const amount = Math.round(parseFloat(this.proTotal) * 100);
      if (
        confirm(
          `Change pro payout amount to ${amount / 100} ${
            this.order.worklog.currency
          } ?`
        )
      ) {
        await api.updateProTotal(this.order.id, amount);
        window.location.reload();
      }
    },
    getInvoiceUrl: function(url = "") {
      if (url.indexOf("googleapis") !== -1) {
        const goodUrl =
          "https://media.discontract.com/storage/invoices/" +
          this.order.invoiceId +
          url.match("/([^/]*).pdf")[0];
        return goodUrl;
      } else {
        return url;
      }
    },
    getScheduledAt: function() {
      if (this.task && this.task.datetime) {
        return dayjs(this.task.datetime.timestamp)
          .tz(this.timezone)
          .format("YYYY-MM-DD HH:mm");
      }
    },
    onPressDate: async function(data) {
      let pros = [];
      if (data.prosAvailable.length) {
        pros = await api.getUsersByIds(data.prosAvailable);
      }
      this.availablePros = pros;
      this.proId = (pros[0] || { id: "" }).id;
      this.rescheduleAt = data.startTime;
    },
    updateRateStats: async function() {
      // console.log(this.rateLimit);
      const stats = Object.assign(this.skillStats, {
        minimum: { EUR: parseInt(this.minRate) },
        limit: { EUR: parseInt(this.rateLimit) }
      });
      await api.updateSkillStats(this.skill.id, stats);
      this.$store.state.skills[this.skill.id].priceStats = stats;
      this.$router.push({ name: "skills" }).catch(err => console.log(err));
    },
    cancelOrder: async function() {
      if (confirm("Are you sure you want to cancel this order?")) {
        // todo add culprit
        await api.cancelOrder(this.order.id, {
          cancelCulpritId: this.cancelCulpritId
        });
        window.location.reload();
      }
    },
    getTransferProDisplayName() {
      const availablePro = this.availablePros.find(p => p.id === this.proId);
      if (availablePro) {
        return [availablePro.firstName, availablePro.lastName].join(" ");
      } else if (this.transferUser) {
        return [this.transferUser.firstName, this.transferUser.lastName].join(
          " "
        );
      } else {
        return false;
      }
    },
    coverExpenses: async function() {
      if (
        confirm(
          "After you cover expenses with discount you will have to send invoices again to client and pro. Are you sure?"
        )
      ) {
        // todo add culprit
        await api.coverExpenses(this.order.id, {
          cancelCulpritId: this.cancelCulpritId
        });
        const invoice = await api.regenerateInvoice(this.order.id);
        await api.generatePdf(invoice.id);
        window.location.reload();
      }
    },
    markAsDispute: async function() {
      if (
        confirm(
          "If you mark order as legal dispute, this order will appear in 'Disputes' tab. Payment notifications will not be sent anymore. Continue?"
        )
      ) {
        // todo add culprit
        await api.setOrderLegalStatus(this.order.id);
        window.location.reload();
      }
    },
    clearPayment: async function() {
      if (
        confirm(
          "You will mark that expenses was paid via wire transfer. Are you sure?"
        )
      ) {
        // todo add culprit
        await api.clearExpenses(this.order.id);
        window.location.reload();
      }
    },
    getOrderDebt() {
      if (!this.worker) {
        return 0;
      } else {
        return (this.worker.debtRecords || []).find(
          r => r.orderId === this.order.id && r.amount > 0
        );
      }
    },
    getCompanyDebt() {
      // console.log(this.company.debtRecordsList, this.order.companyId);
      if (!this.company) {
        return 0;
      } else {
        return (this.company.debtRecordsList || []).find(
          r => r.orderId === this.order.id
        );
      }
    },
    async addCompanyDebt() {
      const amount = Math.round(
        parseFloat(this.companyDebt.replace(",", ".")) * 100
      );
      if (
        confirm(
          `Do you want to add ${amount /
            100} debt for company? This amount will be reduced from next monthly bonus payment.`
        )
      ) {
        await api.addCompanyDebt(this.order.companyId, {
          amount,
          orderId: this.order.id,
          comment: this.companyDebtComment
        });
        window.location.reload();
      }
    },
    stopAutopayment: async function() {
      await api.cancelAutopayment(this.order.id);
      window.location.reload();
    },
    transferOrder: async function() {
      if (
        confirm(
          "Are you sure you want to transfer this order to pro " +
            this.proId +
            " at " +
            dayjs(this.rescheduleAt)
              .tz(this.timezone)
              .format("YYYY-MM-DD HH:mm") +
            "?"
        )
      ) {
        // console.log(api.updateOrder, this.order.id);
        // console.log(this.$store.state.tasks);
        // const task = this.$store.state.tasks[this.order.taskId];
        await api.transfer(this.order.id, {
          proId: this.proId.trim(),
          datetime: this.rescheduleAt,
          addPenalty: this.addPenalty
        });
        window.location.reload();
      }
    },
    rejectTask: async function() {
      if (confirm("Are you sure you want to reject this task?")) {
        await api.rejectTask(this.order.taskId);
        window.location.reload();
      }
    },
    reopenTask: async function() {
      if (confirm("Are you sure you want to reopen this task?")) {
        await api.reopenTask(this.order.taskId);
        window.location.reload();
      }
    },
    assignPhoneNumber: async function() {
      if (
        confirm("Are you sure you want to assign phone number for this task?")
      ) {
        await api.assignPhoneNumber(this.order.taskId);
        window.location.reload();
      }
    },
    deleteInvoice: async invoiceId => {
      if (confirm("Do you really want to delete invoice?")) {
        await api.deleteInvoice(invoiceId);
        window.location.reload();
      }
    },
    getPaymentAmount: function() {
      if (!this.order) {
        return false;
      }
      if (!this.order.paymentStatus) {
        return false;
      }
      if (!this.order.worklog) {
        return false;
      }
      if (this.order.worklog.paymentAmount) {
        return this.order.worklog.paymentAmount / 100;
      } else if (
        this.order.paymentStatus &&
        this.order.paymentStatus !== "paid"
      ) {
        return this.order.worklog.discountedTotal / 100;
      }
    },
    regenerateInvoice: async orderId => {
      if (
        confirm(
          "Are you sure you want to regenrate invoice? Navision registration will remain"
        )
      ) {
        await api.regenerateInvoice(orderId);
        window.location.reload();
      }
    },
    registerInvoice: invoiceId => {
      if (confirm("Check if proId, businessCode and iban exists")) {
        api.registerInvoice(invoiceId);
      }
    },
    generatePdf: invoiceId => {
      if (confirm("Check if documentNumber and proDocumentNumber exists")) {
        api.generatePdf(invoiceId);
      }
    },
    sendProEmail: invoiceId => {
      if (confirm("Check if proEmailSent is true")) {
        api.sendProEmail(invoiceId);
      }
    },
    async loadTransferUser() {
      this.transferUser = null;
      if (this.proId) {
        this.transferUser = await api.getUser(this.proId);
      }
    },
    sendClientEmail: invoiceId => {
      if (confirm("Check if clientEmailSent")) {
        api.sendClientEmail(invoiceId);
      }
    },
    getInvoice: async function() {
      try {
        this.invoice = await api.getInvoice(this.order.id);
        if (!this.order.invoiceId) {
          this.order.invoiceId = this.invoice.id;
        }
        this.showInvoice = true;
        return this.invoice;
      } catch (error) {
        this.showInvoice = false;
        return null;
      }
    },
    canSendPayment: order => {
      if (order.status === "completed" && order.transferStatus !== "paid") {
        return true;
      }
      return false;
    },
    async updateDiscount() {
      const discount = parseFloat(this.discountAmount);
      if (
        confirm(
          `Set order discount to ${discount}? After updating discount you have to: 1) regenerate invoice 2) regenerate pdfs 3) send invoices 4) make partial refund if client already paid full amount`
        )
      ) {
        await api.setDiscount(this.order.id, Math.round(discount * 100));
        window.location.reload();
      }
    },
    sendPayment: order => {
      if (confirm("Are you sure? Check if IBAN exists")) {
        api.sendPayment(order.id);
        order.status = "processing";
      }
    },
    async addProDebt() {
      const amount = Math.round(parseFloat(this.debt.replace(",", ".")) * 100);
      if (
        confirm(
          `Do you want to add ${amount /
            100} debt for pro? This amount will be reduced from next pro payment. Make sure invoices are correct.`
        )
      ) {
        await api.addDebt(this.order.workerId, {
          amount,
          orderId: this.order.id,
          comment: this.debtComment
        });
        window.location.reload();
      }
    },
    setOrder: function(order, task) {
      if (!order.clientInvoiceDetails) {
        order.clientInvoiceDetails = {};
      }
      if (!order.clientInvoiceDetails.address) {
        order.clientInvoiceDetails.address = {};
      }
      this.order = order;
      this.discountAmount = order.worklog
        ? order.worklog.discountAmount / 100
        : 0;
      this.task = task;
      if (this.order.status === "completed") {
        this.getInvoice();
      }
    },
    formatDate: function(date) {
      return new Date(date._seconds * 1000).toLocaleDateString(undefined, {
        hour12: false,
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit"
      });
    }
  },
  data: function() {
    return {
      editingInvoiceDetails: false,
      editAddress: false,
      smsText: "",
      transferUser: null,
      chat: [],
      discountAmount: 0,
      chatAdmin: null,
      showInvoice: false,
      invoice: null,
      order: false,
      orders: [],
      availablePros: [],
      proId: "",
      dayjs: dayjs,
      rescheduleAt: null,
      worker: null,
      owner: null,
      admin: null,
      contact: null,
      company: null,
      client: null,
      cancelCulpritId: "",
      timezone: "Europe/Vilnius",
      proTotal: "0",
      addPenalty: false,
      debt: 0,
      debtComment: "",
      companyDebt: 0,
      companyDebtComment: "",
      addressInput: "",
      addressSuggestions: []
    };
  },
  mounted() {},
  created: async function() {
    document.title = this.$route.params.id;
    const id = this.$route.params.id;
    const state = this.$store.state;
    const order = await api.getOrder(id);
    this.proTotal = order.worklog
      ? (order.worklog.proTotal / 100).toFixed(2)
      : 0;
    this.timezone = timezones[order.country];
    if (order.workerId) {
      this.worker = await api.getUser([order.workerId]);
    }
    if (order.clientId) {
      this.client = (await api.getUsersByIds([order.clientId]))[0];
    }
    if (order.ownerId) {
      this.owner = (await api.getUsersByIds([order.ownerId]))[0];
    }
    if (order.contactId) {
      this.contact = (await api.getContactsByIds([order.contactId]))[0];
    }
    if (order.adminId) {
      this.admin = (await api.getUsersByIds([order.adminId]))[0];
    }
    if (order.companyId) {
      this.company = await api.getCompany(order.companyId);
    }
    order.id = id;
    const task = await api.getTask(order.taskId);
    order.seenAt = this.timeDiff(
      ((task.notifications || {})[task.workerId] || {}).firstTimeOpenedAt,
      task.createdAt
    );
    order.contactSeenAt = this.timeDiff(
      order.contactOpenedDetailsPageAt,
      (order.events[0] || {}).publishedAt
    );
    if (task && task.datetime) {
      this.rescheduleAt = task.datetime.timestamp;
    }
    this.setOrder(order, task);
    // this.task = state.tasks[this.order.taskId];
    this.skill = state.skills[this.order.skillId];
    const chatResp = await api.getChat(order.taskId);
    this.chat = Object.values(chatResp.client).sort((v1, v2) => {
      return v1.createdAt._seconds - v2.createdAt._seconds;
    });
    this.chatAdmin = Object.values(chatResp.admin).sort((v1, v2) => {
      return v1.createdAt._seconds - v2.createdAt._seconds;
    });
    // console.log(this.chat);
  }
};
</script>

<style scoped lang="less">
#order-page,
#order-table {
  grid-template-columns: auto auto auto;
  .row.finished .cell {
    color: #aaa;
  }
  .actions button {
    display: inline-block;
    margin: 10px;
    padding: 10px;
    background-color: black;
    color: white;
    cursor: pointer;
  }
}
</style>
